import { render, staticRenderFns } from "./pi-message.vue?vue&type=template&id=4e5a2c60&scoped=true&"
import script from "./pi-message.vue?vue&type=script&lang=js&"
export * from "./pi-message.vue?vue&type=script&lang=js&"
import style0 from "./pi-message.vue?vue&type=style&index=0&id=4e5a2c60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a2c60",
  null
  
)

export default component.exports